interface EstimateItem {
  name: string;
  category: string;
  unit: string;
  quantity: number;
  unit_price: number;
  total: number;
}

interface EstimateData {
  items?: EstimateItem[];
  labor_cost: number | null;
  material_cost: number | null;
  equipment_cost: number | null;
  margin_amount: number | null;
  total_price: number | null;
  estimated_duration_days: number | null;
}

function formatPLN(value: number | null) {
  if (value == null) return "—";
  return value.toLocaleString("pl-PL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export default function EstimateTable({ estimate }: { estimate: EstimateData }) {
  const rows = [
    { label: "Robocizna", value: estimate.labor_cost },
    { label: "Materiały", value: estimate.material_cost },
    { label: "Sprzęt", value: estimate.equipment_cost },
    { label: "Marża", value: estimate.margin_amount },
  ];

  return (
    <div className="border-2 border-border rounded-lg overflow-hidden bg-card">
      <div className="bg-secondary px-4 py-2 border-b-2 border-border">
        <span className="text-xs font-bold uppercase text-muted-foreground tracking-widest">
          Kosztorys uproszczony
        </span>
      </div>
      <div className="divide-y divide-border">
        {estimate.items && estimate.items.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border bg-secondary/50">
                  <th className="text-left p-3 font-medium text-muted-foreground">Nazwa</th>
                  <th className="text-left p-3 font-medium text-muted-foreground">Kategoria</th>
                  <th className="text-left p-3 font-medium text-muted-foreground">Jedn.</th>
                  <th className="text-right p-3 font-medium text-muted-foreground">Ilość</th>
                  <th className="text-right p-3 font-medium text-muted-foreground">Cena jedn.</th>
                  <th className="text-right p-3 font-medium text-muted-foreground">Razem</th>
                </tr>
              </thead>
              <tbody>
                {estimate.items.map((item, i) => (
                  <tr key={i} className="border-b border-border/50 hover:bg-muted/30">
                    <td className="p-3 text-foreground">{item.name}</td>
                    <td className="p-3 text-muted-foreground">{item.category}</td>
                    <td className="p-3 text-muted-foreground">{item.unit}</td>
                    <td className="p-3 text-right font-mono">{item.quantity}</td>
                    <td className="p-3 text-right font-mono">{formatPLN(item.unit_price)} PLN</td>
                    <td className="p-3 text-right font-mono font-medium">{formatPLN(item.total)} PLN</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {rows.map((row) => (
          <div key={row.label} className="flex justify-between p-4 items-center">
            <span className="text-muted-foreground">{row.label}</span>
            <span className="font-mono font-medium text-lg text-foreground">
              {formatPLN(row.value)}{" "}
              <span className="text-[10px] text-muted-foreground">PLN</span>
            </span>
          </div>
        ))}
        <div className="flex justify-between p-4 items-center bg-foreground">
          <span className="font-bold uppercase tracking-tight text-background">
            Suma Razem
          </span>
          <span className="font-mono text-2xl font-bold text-background">
            {formatPLN(estimate.total_price)}{" "}
            <span className="text-xs text-primary">PLN</span>
          </span>
        </div>
      </div>
      {estimate.estimated_duration_days && (
        <div className="px-4 py-3 border-t-2 border-border bg-secondary">
          <span className="text-sm text-muted-foreground">
            Szacowany czas realizacji:{" "}
            <strong className="text-foreground font-mono">{estimate.estimated_duration_days} dni</strong>
          </span>
        </div>
      )}
    </div>
  );
}
